import { render, staticRenderFns } from "./WorkshopScheduleList.vue?vue&type=template&id=6800538b&scoped=true&"
import script from "./WorkshopScheduleList.vue?vue&type=script&lang=js&"
export * from "./WorkshopScheduleList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopScheduleList.vue?vue&type=style&index=0&id=6800538b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6800538b",
  null
  
)

export default component.exports